import * as React from "react";
import { IconBase, IIconBase } from "src/icons/IconBase";

export const SystemsIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Systems for Machinery Main Components</title>
    <path d="M35.89 21.42H31l-1.88-4.22L31 13h4.89l1.49 1.9 3.15-2.47L37.84 9H28.4l-2.66 6h-9.36l-.06.22L16 16.3l-.15.52L13.07 27h-4l1 4 2.07 8H7v4h29.59l-1-4H22.83l-2.32-8.94 3-10.87h2.12l2.76 6.22h9.44l2.7-3.41-3.15-2.47zM18.1 39h-1.75l-2.08-8h2.35l2.08 8zM29 17.21z" />
  </IconBase>
);
